import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enmascararCuenta',
  pure:true
})
export class EnmascararCuentaPipe implements PipeTransform {

  transform(numeroCuenta: string| null | undefined) {
    if (!numeroCuenta) return '';

    if (numeroCuenta.length < 7) {
      return numeroCuenta;
    } else if (numeroCuenta.length === 7) {
      return numeroCuenta.substring(0, 3) + "XXXX";
    } else {
      return numeroCuenta.substring(0, 3) + "XXXX" + numeroCuenta.substring(7);
    }
  }
}
